import { createSlice } from "@reduxjs/toolkit";
import { AllowedLinkTypes, LinkData, LinkSelect } from "../types/index.js";
import { normalizeLink } from "../utils/utils.js";
import { pressEscapeKey } from "./keyboard.js";

const initialState: LinkSelect = {
  id: undefined,
  linkData: {
    url: null,
    pageId: null,
    languageId: null,
    moduleId: null,
    moduleType: null,
  },
  confirmed: false,
};

interface SetLinkSelectPayload {
  id: string;
  linkData: LinkData;
  confirm: boolean;
  allowedLinkTypes?: AllowedLinkTypes;
}

const linkSelectSlice = createSlice({
  name: "linkSelect",
  initialState,
  reducers: (create) => ({
    setLinkSelect: create.preparedReducer(
      (payload: SetLinkSelectPayload) => ({
        payload: {
          ...payload,
          linkData: {
            ...payload.linkData,
            url: normalizeLink(payload.linkData.url),
          },
        },
      }),
      (state, action) => {
        const { id, linkData, confirm, allowedLinkTypes } = action.payload;
        state.id = id;
        state.linkData = linkData;
        state.confirmed = confirm;
        state.allowedLinkTypes = allowedLinkTypes;
      },
    ),

    resetLinkSelect: create.reducer(() => initialState),
  }),
  extraReducers: (builder) => {
    builder.addCase(pressEscapeKey, () => initialState);
  },
});

export const { setLinkSelect, resetLinkSelect } = linkSelectSlice.actions;

export default linkSelectSlice.reducer;
